import type * as Types from "../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProfileForCalendarSyncQueryVariables = Types.Exact<{
  clientUuid: Types.Scalars["String"]["input"];
  userUuid?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetProfileForCalendarSyncQuery = {
  __typename?: "Query";
  getProfile: {
    __typename?: "Profile";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    primaryImage: string | null;
  };
};

export type ProfileForCalendarSyncFragment = {
  __typename?: "Profile";
  userUuid: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  primaryImage: string | null;
};

export type SyncGoogleCalendarMutationVariables = Types.Exact<{
  userUuid: Types.Scalars["String"]["input"];
}>;

export type SyncGoogleCalendarMutation = {
  __typename?: "Mutation";
  syncGoogleCalendar: { __typename?: "SuccessResponse"; success: boolean };
};

export const ProfileForCalendarSyncFragmentDoc = gql`
  fragment ProfileForCalendarSync on Profile {
    userUuid
    firstName
    lastName
    email
    primaryImage
  }
`;
export const GetProfileForCalendarSyncDocument = gql`
  query GetProfileForCalendarSync($clientUuid: String!, $userUuid: String) {
    getProfile(
      getProfileInput: { clientUuid: $clientUuid, userUuid: $userUuid }
    ) {
      ...ProfileForCalendarSync
    }
  }
  ${ProfileForCalendarSyncFragmentDoc}
`;

/**
 * __useGetProfileForCalendarSyncQuery__
 *
 * To run a query within a React component, call `useGetProfileForCalendarSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileForCalendarSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileForCalendarSyncQuery({
 *   variables: {
 *      clientUuid: // value for 'clientUuid'
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useGetProfileForCalendarSyncQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileForCalendarSyncQuery,
    GetProfileForCalendarSyncQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProfileForCalendarSyncQuery,
    GetProfileForCalendarSyncQueryVariables
  >(GetProfileForCalendarSyncDocument, options);
}
export function useGetProfileForCalendarSyncLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileForCalendarSyncQuery,
    GetProfileForCalendarSyncQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProfileForCalendarSyncQuery,
    GetProfileForCalendarSyncQueryVariables
  >(GetProfileForCalendarSyncDocument, options);
}
export type GetProfileForCalendarSyncQueryHookResult = ReturnType<
  typeof useGetProfileForCalendarSyncQuery
>;
export type GetProfileForCalendarSyncLazyQueryHookResult = ReturnType<
  typeof useGetProfileForCalendarSyncLazyQuery
>;
export type GetProfileForCalendarSyncQueryResult = Apollo.QueryResult<
  GetProfileForCalendarSyncQuery,
  GetProfileForCalendarSyncQueryVariables
>;
export const SyncGoogleCalendarDocument = gql`
  mutation SyncGoogleCalendar($userUuid: String!) {
    syncGoogleCalendar(syncGoogleCalendarInput: { userUuid: $userUuid }) {
      success
    }
  }
`;
export type SyncGoogleCalendarMutationFn = Apollo.MutationFunction<
  SyncGoogleCalendarMutation,
  SyncGoogleCalendarMutationVariables
>;

/**
 * __useSyncGoogleCalendarMutation__
 *
 * To run a mutation, you first call `useSyncGoogleCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGoogleCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGoogleCalendarMutation, { data, loading, error }] = useSyncGoogleCalendarMutation({
 *   variables: {
 *      userUuid: // value for 'userUuid'
 *   },
 * });
 */
export function useSyncGoogleCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncGoogleCalendarMutation,
    SyncGoogleCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncGoogleCalendarMutation,
    SyncGoogleCalendarMutationVariables
  >(SyncGoogleCalendarDocument, options);
}
export type SyncGoogleCalendarMutationHookResult = ReturnType<
  typeof useSyncGoogleCalendarMutation
>;
export type SyncGoogleCalendarMutationResult =
  Apollo.MutationResult<SyncGoogleCalendarMutation>;
export type SyncGoogleCalendarMutationOptions = Apollo.BaseMutationOptions<
  SyncGoogleCalendarMutation,
  SyncGoogleCalendarMutationVariables
>;
